/**
 * Shared page-name helpers. Imported by both page-manager.js and
 * section-manager.js. Lives in its own file so section-manager can use
 * getUniquePageName without creating an import cycle with page-manager
 * (which imports hydratePage from section-manager).
 */

export const PAGE_NAME_MAX_LEN = 60;

export function generatePageId() {
  return 'page-' + crypto.randomUUID().slice(0, 8);
}

export function sanitizePageName(input, fallback = 'Untitled') {
  const trimmed = String(input || '').trim();
  if (!trimmed) return { name: fallback, empty: true, truncated: false };
  if (trimmed.length <= PAGE_NAME_MAX_LEN) return { name: trimmed, empty: false, truncated: false };
  return { name: trimmed.slice(0, PAGE_NAME_MAX_LEN).trim(), empty: false, truncated: true };
}

export function getUniquePageName(state, desiredName, { excludePageId = null } = {}) {
  const used = new Set(
    state.pages
      .filter((p) => p.id !== excludePageId)
      .map((p) =>
        String(p.name || '')
          .trim()
          .toLowerCase()
      )
  );

  if (!used.has(desiredName.toLowerCase())) return desiredName;

  let suffix = 2;
  let candidate = `${desiredName} (${suffix})`;
  while (used.has(candidate.toLowerCase())) {
    suffix++;
    candidate = `${desiredName} (${suffix})`;
  }
  return candidate;
}
